<template>
  <div class="stripe_card_box">
    <b-input
      placeholder="Nome titolare carta"
      class="cardHolder"
      v-model="customer.name"
    ></b-input>
    <div ref="card"></div>
    <b-button
      class="button is-info StripeButton"
      data-secret
      v-on:click="assignCard"
      :loading="stripe_loading || isLoading"
      >Salva Carta</b-button
    >
  </div>
</template>

<script>
// https://stripe.com/docs/payments/cards/reusing-cards#mandates
// https://stripe.com/docs/payments/cards/saving-cards-without-payment

let stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY); // TODO: caccialo globale?
let elements = stripe.elements();
let card = undefined;

export default {
  name: "stripe-card",
  props: ["customer", "setupIntent", "isLoading"],
  data() {
    return {
      stripe_loading: false,
    };
  },
  mounted() {
    card = elements.create("card"); // cardElement
    card.mount(this.$refs.card);

    this.isLoading = true;
  },
  methods: {
    assignCard() {
      let self = this;
      self.stripe_loading = true;
      stripe
        .handleCardSetup(this.setupIntent.client_secret, card, {
          payment_method_data: {
            billing_details: { name: this.customer.name },
          },
        })
        .then(function(result) {
          if (result.error) {
            // Display error.message in your UI.
            self.$dialog.alert({
              message: result.error.message,
              confirmText: "OK",
              scroll: "keep",
              type: "is-danger",
              hasIcon: true,
            });

            self.hasCardErrors = true;
            self.$forceUpdate();
          } else {
            self.$emit(
              "eventSetupIntent",
              self.customer.id,
              result.setupIntent.payment_method,
              card
            );

            // The setup has succeeded. Display a success message.
            // Once the SetupIntent has succeeded, associate the card details with a Customer object.
          }

          self.stripe_loading = false;
        });
    },
  },
};
</script>

<style>
.stripe_card_box {
  margin: 40px 0 20px;
}

.StripeElement {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
  margin: 2px auto 16px;
  max-width: 400px;

  box-sizing: border-box;
  height: 40px;
  padding: 10px 12px;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeButton {
  border: none;
  border-radius: 4px;
  outline: none;
  text-decoration: none;
  color: #fff;
  background: #32325d;
  white-space: nowrap;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding: 0 14px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.025em;
}

.cardHolder {
  margin: 2px auto 16px;
  max-width: 400px;
}
</style>
